<div class="email-recipients-full">
  <div class="recipient-container">
    <div class="recipient-labels">
      <div *ngIf="inboundEmail.fromUser" class="recipient-label">From:</div>
      <div *ngIf="inboundEmail.tos?.length" class="recipient-label">To:</div>
      <div *ngIf="inboundEmail.ccs?.length" class="recipient-label">Cc:</div>
      <div *ngIf="inboundEmail.bccs?.length" class="recipient-label">Bcc:</div>
    </div>
    <div class="recipient-values">
      <div *ngIf="inboundEmail.fromUser" class="recipient-value">
        {{ formatFrom() }}
      </div>
      <div *ngIf="inboundEmail.tos?.length" class="recipient-value">
        <span *ngFor="let to of inboundEmail.tos; let last = last">
          {{ formatRecipient(to) }}{{ !last ? ", " : "" }}
        </span>
      </div>
      <div *ngIf="inboundEmail.ccs?.length" class="recipient-value">
        <span *ngFor="let cc of inboundEmail.ccs; let last = last">
          {{ formatRecipient(cc) }}{{ !last ? ", " : "" }}
        </span>
      </div>
      <div *ngIf="inboundEmail.bccs?.length" class="recipient-value">
        <span *ngFor="let bcc of inboundEmail.bccs; let last = last">
          {{ formatRecipient(bcc) }}{{ !last ? ", " : "" }}
        </span>
      </div>
    </div>
  </div>
  <ion-button
    size="block"
    color="light"
    *ngIf="inboundEmail?.id"
    [routerLink]="['/dashboard', 'inbound-emails', inboundEmail.id]"
    class="btn-small"
    style="margin: 13px 0 0 0"
    (click)="dismiss()"
  >
    View full email
    <ion-icon
      name="chevron-forward-outline"
      class="icon-padded-left"
    ></ion-icon>
  </ion-button>
</div>
